export default "__VITE_ASSET__iMbJSYUW__"